import axios from "axios";
import { getUserInfo } from "./utils/authStorage";

const baseUrl = process.env.REACT_APP_BE_URL || "http://localhost:5002";

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use((config) => {
  try {
    const token = getUserInfo()?.token;
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch (err) {
    // ignore
  }
  return config;
});

export default axiosInstance;
